import classNames from "classnames";
import React from "react";

import css from "./color_badge.module.scss";

interface IProps {
  color: string;
  editMode: boolean;
  onColorEdit: () => void;
  editedColor: string | null | undefined;
}

const ColorBadge = ({ color, editMode, onColorEdit, editedColor }: IProps) => {
  const enterEditMode = editMode || color.length === 0;
  const Tag = enterEditMode ? "button" : "div";
  return (
    <span className={css.wrapper}>
      <Tag
        onClick={() => {
          enterEditMode && onColorEdit();
        }}
        style={{ backgroundColor: editedColor || color || "var(--Palette-status-base)" }}
        className={classNames(css.colorBadge, { [css.buttonStyle]: enterEditMode })}
      />
    </span>
  );
};

export default ColorBadge;
